import React, { Component, version } from "react";
import { render } from "react-dom";
import { BrowserRouter } from "react-router-dom";
import axios from "axios";
import { Provider } from "react-redux";
import configureStore from "./store";
import { PersistGate } from "redux-persist/integration/react";
import * as serviceWorker from "./serviceWorker";
import Layout from "./Layout/Layout";
import {
  loginAccessToken,
  accountAccessToken,
  setBaseUrl,
  setNetworkDrop,
} from "./store/slice/login-slice";
import api from "./utils/api";
import Swal from "sweetalert2";
import jwt_decode from "jwt-decode";
import { ConfigProvider, Result, message } from "antd";
import { getToken } from "firebase/messaging";
import { messaging } from "./firebase";
import { ErrorBoundary } from "react-error-boundary";
import ErrorFallback from "Layout/ErrorFallback";
import { ThemeProvider } from "styled-components";
import {
  MeetingProvider,
  lightTheme,
  GlobalStyles,
} from "amazon-chime-sdk-component-library-react";
import './i18n';
import { VERSION_1_7_0, VERSION_1_8_0, VERSION_1_9_0, VERSION_1_9_1, VERSION_1_10_0, VERSION_1_11_0} from "Common/constant";
const { store, persistor } = configureStore();
window.ErrorDuration = 10;

axios.defaults.baseURL = process.env.REACT_APP_API_URL;
const instance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

const requestArray = [];
axios.defaults.headers.post["Content-Type"] = "application/json";

axios.interceptors.request.use(
  (config) => {
    if (
      !config?.url?.endsWith("list-chat/") &&
      !config?.url?.endsWith("chat-niyama/")
    )
      // /refresh/
      document.body.classList.add("loading-indicator");
    let defaultStore = store.getState();
    let configSplit = config.url.split("/");
    // let urlFetch = process.env.REACT_APP_ENV == "dev" ? configSplit[5] : configSplit[6] ;
    // let version = "";
    // if(VERSION_1_7_0.includes(urlFetch)){
    //   version = "v1.7.0";
    // }
    // if(VERSION_1_8_0.includes(urlFetch)){
    //   version = "v1.8.0";
    // }
    // if(VERSION_1_9_0.includes(urlFetch)){
    //   version = "v1.9.0";
    // }
    // if(VERSION_1_9_1.includes(urlFetch)){
    //   version = "v1.9.1";
    // }
    // if(VERSION_1_10_0.includes(urlFetch)){
    //   version = "v1.10.0"
    // }
    // if(VERSION_1_11_0.includes(urlFetch)){
    //   version = "v1.11.0"
    // }
    // if(version){
    //   if(process.env.REACT_APP_ENV == "dev")
    //     configSplit[4] = version;
    //   else
    //     configSplit[5] = version;
    // }
    
    let current_role = defaultStore.loginReducer.user_details.role;
    let url_edge = "";
    if(current_role == "patient"){
      url_edge="patient-edge"
    }else if(current_role == "doctor"){
      url_edge = "doctor-edge";
    }else if(current_role == "care-admin"){
      url_edge = "care-admin-edge";
    }
    else if(current_role == "super_admin"){
      url_edge = "super-admin-edge";
    }
    if( !config?.url?.endsWith("close-chat/") && !config?.url?.endsWith("update-conversation-attributes/") && !config?.url?.endsWith("patient-chat-token-details/") && !config?.url?.endsWith("update-care-admin-status/") && !config?.url?.endsWith("get-care-chat-status/")){
      if (process.env.REACT_APP_ENV == "dev" && configSplit[3] == "auth-manager")
        configSplit[3] = "auth-manager-edge"
      else if (configSplit[4] == "niyama-api")
        configSplit[4] = "auth-manager-edge"

      if (process.env.REACT_APP_ENV == "dev" && configSplit[4] == "v1.6.0" && (configSplit[3] == "niyama-api" || configSplit[3] == "auth-manager-edge")) {
        configSplit.splice(4, 1)
      } else if (configSplit[5] == "v1.6.0" && (configSplit[4] == "niyama-api" || configSplit[4] == "auth-manager-edge")) {
        configSplit.splice(5, 1)
      }


      if (process.env.REACT_APP_ENV == "dev" && configSplit[3] == "niyama-api") {
        configSplit[3] = url_edge;
      } else if (configSplit[4] == "niyama-api") {
        configSplit[4] = url_edge;
      }
    }
 
    config.url = configSplit.join("/");
    if(config?.url?.endsWith("phi/create-document")) {
      config.url = `${process.env.REACT_APP_ANALYTICS_URL}phi/create-document`;
    }
    if(config?.url?.includes("phi/delete-document")) {
      config.url = `${process.env.REACT_APP_ANALYTICS_URL}phi/delete-document`;
    }
    if ( defaultStore.loginReducer.user_details.role != "Guest" && !config?.url?.endsWith("/refresh/")) {
      let token = defaultStore.loginReducer.user_details?.access_token;
      if (
        config?.url?.endsWith("profile-detail/") ||
        config?.url?.endsWith("profile-list/") ||
        config?.url?.endsWith("profile-create/") ||
        ((config?.url?.endsWith("user-info/") || config?.url?.endsWith("get-all-timezones/") || config?.url?.endsWith("get-all-languages/") || config?.url?.endsWith("preferred-language-update/")) && location.pathname != '/logged-in-user/my-account-child') || (config?.url?.endsWith("time-zone-update/") && location.pathname != '/logged-in-user/my-account-child' && location.pathname != '/logged-in-user/dashboard') ||
        config?.url?.endsWith("whatsapp-settings/") ||
        config?.url?.endsWith("account-inactivate/") || config?.url?.endsWith("check-role/") || (location.pathname == '/role-types/select-role' && config?.url?.endsWith("get-patient-status/")) || config?.url?.endsWith("get-doctor-status/")  || config?.url?.endsWith("get-care-admin-status/") || config?.url?.endsWith("get-client-admin-status/") || config?.url?.endsWith("get-super-admin-status/")
      ) {
        token = defaultStore.loginReducer?.account_details?.access_token || "";
        if (!token) return Promise.reject({ config, token_expiry: true });
        const { exp } = jwt_decode(token);
        const expirationTime = exp * 1000;
        if (Date.now() >= expirationTime) {
          return Promise.reject({ config, token_expiry: true });
        }
      }
      // token = "eyJhbGciOiJSUzUxMiIsInR5cCI6IkpXVCJ9.eyJ0b2tlbl90eXBlIjoiYWNjZXNzIiwiZXhwIjoxNjc1OTE4OTkwLCJqdGkiOiI5ZTkwZmMyMDViY2I0ZTYzOWI5MTEyNWY1YjBkYzE1OCIsInVzZXJfaWQiOjI0Nn0.aK7x0qQr5LmcrTOM238gMsj3TC6Oqi1R4QgOAHL5s9YArN4oPgNOKJj45_6-aHTLTQGRBrSVzrh4jmzdN0O9kUfRCdzNFQ6fAJiBngmuU2lghdqsjLgXQR6CE_jZ5Yin65ixkfs6qJ6KqON0kACVf7xo2cB6lnfSSvIYOh0YvegZaMUrpXnqWwMsIfQ7ecS6Hsogb4RcWSKI5_30gV0_e9kC50AhUvTHCzPPkZf5DixKdX1VfCO7Ck45mxWF43ZBYE2p4DFHD4gMUfFeR2gTCEaeaAHUn_WhUNHwMynQix-pZnAJO-BPZYReSKDdqyPniQJGM8yLYweXfU3B7g8C0g"
      config.headers["Authorization"] = "Bearer " + token;
      const { exp } = jwt_decode(token);
      const expirationTime = exp * 1000;
      if (Date.now() >= expirationTime) {
        return Promise.reject({ config, token_expiry: true });
      }
    }
    // message.destroy();
    message.config({
      // top: 500,
      // duration: 5,
      maxCount: 3,
      // rtl: true,
      // prefixCls: 'my-message',
    });
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  (res) => {
    document.body.classList.remove("loading-indicator");
    // if (requestArray.length !== 0) {
    //   requestArray.forEach(function (x, i) {
    //     if (res.config?.url == x?.url) {
    //       requestArray.splice(i, 1);
    //     }
    //   });
    // }

    return res;
  },
  async (err) => {
    let defaultStore = store.getState();
    if (!navigator.onLine && !defaultStore?.loginReducer?.networkError) {
      store.dispatch(setNetworkDrop(true));
    }
    document.body.classList.remove("loading-indicator");
    const originalConfig = err.config;

    requestArray.push(originalConfig);

    if (err.response || err?.token_expiry) {
      // Access Token was expired
      if (
        (err?.response?.status === 401 && !originalConfig._retry) ||
        err?.token_expiry
      ) {
        if (
          (err.response?.data?.code == "token_not_valid" ||
            err?.token_expiry) &&
          originalConfig?.url?.endsWith("/refresh/")
        ) {
          let keysToRemove = [
            "subscription",
            "persist:root",
            "rzp_device_id",
            "isLoggedIn",
            "gender",
            "patient_id",
            "patient_user_type",
            "patient_gender",
            "phiReducer",
            "patient_type",
            "is_completed",
            "setGuestUUID",
          ];
          for (let key of keysToRemove) {
            localStorage.removeItem(key);
          }
          store.dispatch({ type: "USER_LOGOUT" });
          Swal.fire({text: "Your session has expired. Please login again.",
            showConfirmButton: false,
            allowOutsideClick: false,
            timer: 3000,
            timerProgressBar: true,
            icon: "info",
          });
          setTimeout(() => {            
            // swal("Your session has expired, Please login again.", { button: false });
            // if (
            //   process.env.REACT_APP_ENV != "dev" &&
            //   process.env.REACT_APP_ENV != "test"
            // )
            //   window.location.href = "https://www.niyama.ai/";
          }, 3000);
          return;
        }

        originalConfig._retry = true;
        try {
          let isAccount = false;
          if (
            originalConfig?.url?.endsWith("profile-detail/") ||
            originalConfig?.url?.endsWith("profile-list/") ||
            originalConfig?.url?.endsWith("profile-create/") || originalConfig?.url?.endsWith("check-role/") || (location.pathname == '/logged-in-user/select-role' && originalConfig?.url?.endsWith("get-patient-status/")) || originalConfig?.url?.endsWith("get-doctor-status/")  || originalConfig?.url?.endsWith("get-care-admin-status/") || originalConfig?.url?.endsWith("get-client-admin-status/") || originalConfig?.url?.endsWith("get-super-admin-status/")
          ) {
            isAccount = true;
          }
          const rs = await refreshToken(isAccount);
          if (!rs?.data?.access) {
            let keysToRemove = [
              "subscription",
              "persist:root",
              "rzp_device_id",
              "isLoggedIn",
              "gender",
              "patient_id",
              "patient_user_type",
              "patient_gender",
              "phiReducer",
              "patient_type",
              "setGuestUUID",
              "is_completed"
            ];
            for (let key of keysToRemove) {
              localStorage.removeItem(key);
            }
            store.dispatch({ type: "USER_LOGOUT" });
            Swal.fire({text: "Your session has expired. Please login again.",
              showConfirmButton: false,
              allowOutsideClick: false,
              timer: 3000,
              timerProgressBar: true,
              icon: "info",
            });
            setTimeout(() => {              
              // swal("Your session has expired, Please login again.", { button: false });
              // if (
              //   process.env.REACT_APP_ENV != "dev" &&
              //   process.env.REACT_APP_ENV != "test"
              // )
              //   window.location.href = "https://www.niyama.ai/";
            }, 3000);
            return;
          }
          const accessToken = rs.data.access;
          localStorage.setItem("isLoggedIn", true);
          if (isAccount) store.dispatch(accountAccessToken(accessToken));
          else store.dispatch(loginAccessToken(accessToken));
          // if (requestArray.length !== 0) {
          //   requestArray.forEach((x) => {
          //     try {
          //       x.headers["Authorization"] = "Bearer " + accessToken;
          //       instance(x);
          //     } catch (e) {
          //       console.log(e);
          //     }
          //   });
          // }
          originalConfig.headers["Authorization"] = 'Bearer ' + accessToken;

          return instance(originalConfig);
        } catch (_error) {
          if (_error.response && _error.response.data) {
            return Promise.reject(_error.response.data);
          }

          return Promise.reject(_error);
        }
      }
      if (err.response.status === 500 || err.response.status === 429) {
        window.alert("Internal Server Error. Please try again later");
        return Promise.resolve({ data: { data: { results: [] } } });
      }
      if (err.response.status === 403 && err.response.data) {
        return Promise.reject(err.response.data);
      }
    }

    return Promise.reject(err);
  }
);
function refreshToken(isAccount) {
  let defaultStore = "";
  if (isAccount) {
    store.dispatch(accountAccessToken(""));
    defaultStore = store.getState();
    if (!defaultStore.loginReducer.account_details?.refresh_token) return "";
  } else {
    store.dispatch(loginAccessToken(""));
    defaultStore = store.getState();
    if (!defaultStore.loginReducer.user_details?.refresh_token) return "";
  }
  return api.jwtRefresh({
    refresh: isAccount
      ? defaultStore.loginReducer.account_details?.refresh_token
      : defaultStore.loginReducer.user_details?.refresh_token,
  });
}

class App extends Component {
  constructor() {
    super();
    this.state = {
      name: "React",
    };
  }

  // async requestPermission() {
  //   const permission = await Notification.requestPermission();
  //   if (permission === "granted") {
  //     // Generate Token
  //     const token = await getToken(messaging, {
  //       vapidKey:
  //         "BKckxG5Wsfhvlbl7ma0sQyR_jKyzDAcqW3ww7H0iw6ZoCpyeJ6Wps-FLZgbBv4kx2lqXP_tUygm8w2jrKpw2RFw",
  //     });
  //     // Send this token  to server ( db)
  //   } else if (permission === "denied") {
  //     // alert("You denied for the notification");
  //   }
  // }

  componentDidMount() {
    const script1 = document.createElement("script");
    script1.setAttribute(
      "src",
      process.env.REACT_APP_ENV == "dev"
        ? "https://uat.billdesk.com/jssdk/v1/dist/billdesksdk/billdesksdk.esm.js"
        : "https://pay.billdesk.com/jssdk/v1/dist/billdesksdk/billdesksdk.esm.js"
    );
    script1.setAttribute("type", "module");
    script1.id = "script1";

    const script2 = document.createElement("script");
    script2.setAttribute(
      "src",
      process.env.REACT_APP_ENV == "dev"
        ? "https://uat.billdesk.com/jssdk/v1/dist/billdesksdk.js"
        : "https://pay.billdesk.com/jssdk/v1/dist/billdesksdk.js"
    );
    script2.setAttribute("nomodule", "");
    script2.id = "script2";

    const script3 = document.createElement("Link");
    script3.href =
      process.env.REACT_APP_ENV == "dev"
        ? "https://uat.billdesk.com/jssdk/v1/dist/billdesksdk/billdesksdk.css"
        : "https://pay.billdesk.com/jssdk/v1/dist/billdesksdk/billdesksdk.css";
    script3.id = "script3";

    document.body.appendChild(script1);
    document.body.appendChild(script2);
    document.body.appendChild(script3);
    // this.requestPermission();
  }
  render() {
    const customDefaultProps = {      
      Collapse: {        
        collapsible: 'icon',
        // defaultActiveKey: generateNumbersArray(data),
      },
      Panel: {
        showArrow: false,
      },     
    };
    
    return (
      <ThemeProvider theme={lightTheme}>
      <GlobalStyles />
      <MeetingProvider>
          <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>
              <BrowserRouter>
                <ErrorBoundary
                  FallbackComponent={({ error, resetErrorBoundary }) => (
                    <ErrorFallback
                      error={error}
                      resetErrorBoundary={resetErrorBoundary}
                    />
                  )}
                >
                  {/* <ConfigProvider {...customDefaultProps}> */}
                  <Layout />
                  {/* </ConfigProvider> */}
                </ErrorBoundary>
              </BrowserRouter>
            </PersistGate>
          </Provider>
          </MeetingProvider>
      </ThemeProvider>
    );
  }
}
if (window.self === window.top) {
  render(
    <div onContextMenu={(e) => e.preventDefault()}>
      <App />
    </div>,
    document.getElementById("root")
  );
} else {
  render(
    <Result
      status="403"
      title="403"
      subTitle="Sorry, you are not authorized to access this page."
    />,
    document.getElementById("root")
  );
}

serviceWorker.unregister();
